export const ERR_SOMETHINGWENTWRONG = 'Something went wrong, please try again later';

export const ERR_WORKSPACE_CREATE_FAILED = 'Failed to create workspace';

export const ERR_NO_ORGS = "You don't have access to any organizations";
export const ERR_INVALID_EMAIL = 'Invalid Email';
export const ERR_EMPTY_EMAIL = 'Email cannot be empty';
export const ERR_NAME_CANNOT_BE_EMPTY = 'Name cannot be empty';
export const AWS_AMPLIFY_SYSTEM_MESSAGE = 'Invalid SAML response received: PreSignUp failed with error';
export const ERR_EMAIL_NOT_CONFIGURED_WITH_SAML = 'This email is not configured to use SAML SSO. Check your email again or Sign In with Password';
export const ERR_CANNOT_RESET_PASSWORD_FOR_SSO_EMAIL = 'This email is SSO registered, so you cannot reset password. Use Single Sign-On option to login without password.';
export const ERR_USER_NOT_FOUND_FOR_FORGOT_PASSWORD = 'Code will be sent to this email if it is registered';
export const SUCCESS_SAML_CONFIGURED = 'SAML Configuration Updated Successfully';
export const INVALID_PASSWORD_ERROR = 'Password must be at least 8 characters, include a number and a special character';

export const ERR_PROJECT_DELETE_FAILED = 'Failed to delete project';
export const SUCCESS_PROJECT_DELETE = 'Project Deleted Successfully';
export const ERR_PROJECT_NOT_FOUND = 'This project no longer exists or has been deleted';
export const ERR_PROJECT_CREATE_FAILED = 'Failed to create project';
export const ERR_PROJECT_MODIFY_FAILED = 'Failed to modify project';
export const INFO_PROJECT_WORKSPACE_CHANGED = 'Project moved to new workspace by another user. Reloading Project';
export const INFO_WORKSPACE_DELETED_REMOTELY = 'Workspace is deleted. Switching workspace';

export const SUCCESS_CHANGE_GROUP_CALENDAR_ID = 'Group duration calendar changed. \n Data will update on next Schedule run.';
export const ERR_CALENDAR_CREATE_FAILED = 'Failed to create calendar';
export const ERR_CALENDAR_EDIT_FAILED = 'Failed to edit calendar';
export const ERR_CALENDAR_DUPLICATE_FAILED = 'Failed to duplicate calendar';

export const ERR_CANVAS_PASTE_MISSINGREACTFLOW = "Couldn't paste as react flow instance is missing?";
export const ERR_CANVAS_PASTE_MISSINGELEMENT = "Couldn't paste as original element not found.";
export const ERR_CANVAS_STUBMOVE_FAILED = 'Failed to move stub';
export const ERR_CANVAS_DROPPOSITION_FAILED = 'Failed to detect absolute drop position. Falling back to relative position [POSITION]';
export const ERR_CANVAS_ELEMENTLOOP = "An element can't be child of itself";
export const ERR_CANVAS_SUMMARYEDGESDELETE_FAILED = 'Summary edges to groups cannot be deleted directly';
export const ERR_CANVAS_STUB_DELETE_FAILED = 'Please go to the Activity to delete it';
export const ERR_CANVAS_MOVEACTIVITY_FAILED = 'Failed to move activity on server';
export const ERR_CANVAS_MOVEACTIVITY_FAILED_DELETED = 'Failed to move activity. No longer present.';
export const ERR_CANVAS_MOVEACTIVITY_FAILED_TEMPORARY = 'Failed to move activity. Not created yet.';
export const INFO_CANVAS_ELEMENTMOVE = 'Element moved successfully';
export const INFO_CANVAS_ELEMENTS_MOVE = 'Elements moved successfully';

export const ERR_SEND_INVITE = 'Failed to send invite';
export const ERR_SWITCHDURATION_TOGGLEFAILED = 'Failed to toggle duration';

export const ERR_CONTEXTMENU_CONNECTFS_FAILED = 'Failed to connect elements in FS';
export const ERR_CONTEXTMENU_GROUP_FAILED = 'Failed to group';
export const ERR_CONTEXTMENU_CONVERTTOGROUP_FAILED = 'Failed to convert activity to group [GUID]';
export const ERR_CONTEXTMENU_COPY_NOELEMENTS = 'No elements selected to copy';
export const INFO_CONTEXTMENU_CONNECTFS = '([LENGTH]) Elements connected in FS';
export const INFO_CONTEXTMENU_CONNECTFS_ALREADYCONNECTED = 'Elements already connected';

export const ERR_DYNAMICNODE_UPDATEACTIVITY_FAILED = 'Failed to update activity';

export const ERR_CHANGE_CONNECTION_ALREADY_EXISTS = 'Connection already exists!';
export const ERR_UPDATE_CONNECTION_FAILED = 'Failed to update connection';

export const INFO_CUSTOMDATEPICKER_INVALIDDATE = 'Please enter a valid date';

export const ERR_RUNCPM_FAILED = 'CPM run failed';
export const INFO_RUNCPM_COMPUTED = 'New schedule calculated';
export const MISSING_SUCCESSOR_FOR_START_MILESTONE = 'Missing successor for start milestone';

export const ERR_EXPORTPROJECT_FAILED = 'Failed to export project';
export const INFO_EXPORTPROJECT = 'Project Exported Successfully';
export const INFO_IMPORTPROJECT = 'Project Imported Successfully';
export const ERR_IMPORTPROJECT_FAILED = 'Failed to import project';
export const ERR_IMPORTPROJECT_BAD_FILE = 'File Format is Invalid';
export const INFO_DOWNLOADPROJECT = 'Project Downloaded Successfully';
export const ERR_DOWNLOADPROJECT_FAILED = 'Failed to download project';

export const SUCCESS_CHANGE_COMMIT_STATUS = 'Project State Changed Successfully!';
export const ERR_CHANGE_COMMIT_STATUS = 'Failed to change committed status';

export const ERR_RESOURCE_EDIT_FAILED = 'Failed to edit resource';

export const ERR_TABLE_PASTERESOURCES_FAILED = 'An error occured while pasting some resources!';
export const INFO_TABLE_PASTING_INPROGRESS = 'Pasting...';
export const INFO_TABLE_PASTERESOURCES_INPROGRESS = 'Pasting resources... This may take a few moments!';
export const INFO_TABLE_PASTERESOURCES_OK = 'Resources pasted successfully!';

export const ERR_ELEMENTRESOURCES_LOAD_FAILED = 'Unable to load resources. Adding resources will not be possible.';
export const INFO_ELEMENTRESOURCES_LABOR_CREATE = 'New labor created';
export const INFO_ELEMENTRESOURCES_EQUIPMENT_CREATE = 'New equipment created';

export const ERR_AUTOLAYOUT_UPDATE_FAILED = 'Failed to update all elements on server after layout';

export const ERR_HANDLE_CONNECTIONEXISTS = 'Connection already exists';
export const ERR_HANDLE_CIRCULAR_CONNECTION = 'Circular connections are not allowed';
export const CONNECCTION_SUCCESSFULLY_CREATED = 'Connection successfully created';

export const ERR_STUB_MOVE_FAILED = 'Failed to move stub';

export const ERR_SCHEDULER_SETPOSITION_FAILED = 'Failed to set new position after removing child from parent';
export const ERR_SCHEDULER_MOVECHILD_FAILED = 'Failed to move child out of parent';
export const ERR_SCHEDULER_MOVEACTIVITY_FAILED = 'Failed move acitivty into new parent';
export const ERR_SCHEDULER_UPDATE_FAILED = 'Update error acitvity is child, but position has not updated';
export const ERR_SCHEDULER_COPY_FAILED = 'Copy failed';
export const ERR_SCHEDULER_CREATEELEMENT_FAILED = 'Failed to create element';
export const ERR_SCHEDULER_MOVEACTIVITY_API_FAILED = 'Failed to move activity on server';
export const ERR_SCHEDULER_CREATEPREDECESSOR_FAILED = 'Failed to create predecessor';
export const ERR_SCHEDULER_LOOP = "Cannot make element child of it's own descendant";
export const ERR_SCHEDULER_ALREADYCHILD = '[GUID_A] is already a child of [GUID_B]';

export const ERR_UNDO_CREATE_FAILED = 'Undo create failed';
export const ERR_UNDO_DELETE_FAILED = 'Undo delete failed';
export const ERR_UNDO_UPDATE_FAILED = 'Undo update failed';
export const ERR_UNDO_CONNECTION_FAILED = 'Undo delete failed';
export const ERR_UNDO_GENERIC_FAILED = 'Failed to undo action: [TYPE]';
export const INFO_UNDO_OK = 'Undo';
export const INFO_UNDO_NOOP = 'Nothing to undo';

export const ERR_OPTION_ALREADY_EXIST = 'Option already exist';
export const REFRESH_SCHEDULE_TO_UPDATE_GRAPH = 'Refresh the schedule to update the graph';
export const REFRESH_SCHEDULE_TO_UPDATE_GANTT = 'Refresh the schedule to update the gantt';

export const ELEMENT_IS_HIDDEN_BECAUSE_OF_FILTER = 'Target Element is Hidden because of Filter';
export const ELEMENT_IS_HIDDEN_BECAUSE_OF_INSPECT_PATH = 'Target Element is Hidden because of inspect path';
export const TARGET_ELEMENT_IS_DELETED = 'Target Element is Deleted';

export const LINKED_PROJECT_NOT_AVAILABLE = 'Linked Project no longer available.';

export const ONLY_EQUIPMENTS_CAN_BE_COPIED_INTO_EQUIPMENT_COLUMN = 'Only equipments can be copied into equipment column';
export const ONLY_LABORS_CAN_BE_COPIED_INTO_LABOR_COLUMN = 'Only labors can be copied into labor column';
export const ONLY_NAMES_CAN_BE_COPIED_INTO_NAME_COLUMN = 'Only names can be copied into name column';
export const ONLY_DURATIONS_CAN_BE_COPIED_INTO_DURATION_COLUMN = 'Only durations can be copied into duration column';
export const ONLY_CALENDARS_CAN_BE_COPIED_INTO_CALENDAR_COLUMN = 'Only calendars can be copied into calendar column';
export const ONLY_WORK_HOURS_CAN_BE_COPIED_INTO_WORK_HOURS_COLUMN = 'Only work hours can be copied into work hours column';
export const ONLY_VARIANCE_CODES_CAN_BE_COPIED_INTO_VARIANCE_CODES_COLUMN = 'Only variance codes can be copied into variance codes column';

export const START_MILESTONE_CANNOT_HAVE_FF_RELATION = "Start milestone can't have FF relation";
export const END_MILESTONE_CANNOT_HAVE_SUCCESSORS = "Finish milestone can't have successors";
export const START_MILESTONE_CANNOT_BE_A_TARGET = "Start milestone can't be a target";
export const END_MILESTONE_CANNOT_BE_A_SOURCE = "Finish milestone can't be a source";
export const ELEMENT_CANNOT_BE_CONNECTED_TO_ITSELF = "Element can't be connected to itself";
export const CUSTOM_CODE_CAN_ONLY_BE_COPIED_IN_SAME_FIELD = 'Code can only be copied in same field';
export const NOTHING_TO_PASTE = 'Nothing to paste';
export const ERR_PASTE_ACROSS_ORGANIZATIONS = 'Cannot paste across organizations';
export const CLIPBOARD_PERMISSIONS_MISSING = 'Please Grant Clipboard Permissions';

export const ELEMENT_REMOVED_TO_WATCH_LIST = 'Element removed from watchlist';
export const ADDED_TO_WATCH_LIST = 'added to watchlist';

export const CANVAS_PDF_DOWNLOAD_SUCCESS = 'Canvas PDF Downloaded Succesfully!';

export const EXPECTED_FINISH_IS_BEFORE_DATA_DATE = 'Expected Finish is before Data Date';
export const EXPECTED_FINISH_CAN_NOT_BE_BEFORE_ACTUAL_START_DATE = 'Expected Finish can not be before Actual Start date';
export const EXPECTED_FINISH_IS_BEFORE_LOGIC_DRIVEN_START_DATE = 'Expected Finish is before logic driven Start Date. So Remaining Duration is 0';
export const ACTUAL_FINISH_CAN_NOT_BE_BEFORE_ACTUAL_START_DATE = 'Actual Finish can not be before Actual Start date';
export const ACTUAL_START_IS_AFTER_DATA_DATE = 'Actual Start is after Data Date';
export const ACTUAL_START_CAN_NOT_BE_BEFORE_PROJECT_START_DATE = 'Actual Start can not be before Project Start Date';
export const ACTUAL_FINISH_IS_AFTER_DATA_DATE = 'Actual Finish is after Data Date';
export const DATA_DATE_CAN_NOT_BE_BEFORE_PROJECT_START_DATE = 'Data Date can not be before Project Start Date';
export const ENTER_A_VALID_DATE = 'Please enter a valid date';
export const DATE_IS_BEFORE_MIN_DATE = 'Date is before the minimum date';
export const DATE_IS_AFTER_MAX_DATE = 'Date is after the maximum date';
export const NON_WORKING_DATE_ERROR = 'Cannot enter non-working days';
export const FAILED_TO_APPLY_FS_UPDATES = 'Failed to apply updates. Please try again later.';

export const SCHEDULE_PROJECT_BEFORE_SETTING_DATA_DATE = 'Please schedule the project before setting Data Date';
export const PROGRESS_UPDATES_REVERTED_DUE_TO_DATE_ERRORS = 'Date reverted back to previous value';
export const ACTIVITY_STATUS_REVERTED = (activityName: string) => `Action incomplete, ${activityName} reverted back to previous activity status`;

export const ACTIVITY_IDS_SUCCESSFULLY_EDITED = 'Activity IDs Successfully Edited';
export const ACTIVITY_IDS_SUCCESSFULLY_REPLACED = 'Activity IDs Successfully Replaced';
export const ACTIVITY_IDS_DISALLOWED = 'IDs of format [A-C]#### are reserved for use by Planera. Please choose another ID.';

export const FAILED_COMMENT_ADD = 'Failed to add comment';
export const FAILED_COMMENT_UPDATE = 'Failed to update comment';

export const FAILED_VERSION_CREATE = 'Failed to create version';

export const ONLY_ADMINS_CAN_EDIT_LOGO_ORG = 'Only Admins can edit logo';
export const ONLY_OWNER_EDITOR_CAN_EDIT_LOGO = 'Only Owner and Editor can edit logo';

export const ORGANIZATION_REPORT_LOADING_MSG = 'Generating Report';

export const SHARING_DISABLED_MESSAGE = 'Move Project to a Shared Workspace to invite other members';
export const PRIVATE_PROJECT_DISABLED = 'Projects in the Sandbox folder cannot be added';
export const PRJECT_SELECTION_DISABLED_CPM_MSG = 'Project needs to be scheduled at least once \nbefore it can be added to report';

export const ELEMENT_AUTOASSIGNED_MESSAGE = 'You have been assigned as owner of this element as it was previously unknown.';
export const PARENT_DELETE_PERMISSION_MESSAGE = 'This Element cannot be deleted as it contains elements that you do not have edit rights to';

export const ERR_NO_ACCESS_TO_PROJECT = 'You Do not have access to this project anymore.';
export const ERR_ORGANIZTION_FIELD_EDIT_FAILED = 'Failed to edit organization field';

export const FIELD_SCHEDULE_DEMO_REQUEST = "I'm interested in learning more about Field Schedules. Can we schedule a quick demo?";

export const UNDO_TOOLTIP_TEXT = 'Undo';

export const MANNY_FEEDBACK_TRACE_ID_ERROR = 'Sorry, we could not record your feedback for this message.';
export const MANNY_FEEDBACK_SUCCESS = 'Thank you for your feedback!';
export const MANNY_FEEDBACK_SUBMIT_ERROR = 'Failed to submit feedback. Please try again.';

export const MANNY_DELETE_SESSION_NOT_FOUND = 'Session not found';
export const MANNY_DELETE_SESSION_FAILED = 'Failed to delete conversation';

export const MANNY_ERROR_MESSAGE_CLIENT = 'I ran into a temporary issue while generating a response.';
export const MANNY_ERROR_MESSAGE_SERVER = 'I ran into a temporary issue while generating a response. Please try again later.';

export const MANNY_CONTEXT_LIMIT_LASSO = 'Maximum context items reached. Some items were not added.';
export const MANNY_CONTEXT_ALREADY_SELECTED = 'This item is already added as context.';
